import axios, { AxiosError, AxiosInstance, AxiosRequestConfig } from 'axios'

export const SERVER_URL = 'https://allsharing.di-dev.ru'
// export const SERVER_URL = 'https://allsharing.af-dev.ru'
// export const SERVER_URL = 'https://allsharing.su'

export const apiClient: { isAwaitRefresh?: boolean } & AxiosInstance = axios.create({
  baseURL: SERVER_URL,
  headers: {
    'Access-Control-Allow-Headers': '*',
    'Access-Control-Allow-Methods': '*',
    'Access-Control-Allow-Origin': '*',
    // 'Content-type': 'application/json',
  },
  withCredentials: true,
})
apiClient.isAwaitRefresh = false

const isBrowser = typeof window !== 'undefined'

const getStoredValue = (key: string): null | string => {
  if (!isBrowser) {
    return null
  }

  const value = localStorage.getItem(key)

  if (!value || value === 'undefined') {
    return null
  }

  return value
}

const parseStoredJSON = <T>(key: string): null | T => {
  const value = getStoredValue(key)

  if (!value) {
    return null
  }

  try {
    return JSON.parse(value) as T
  } catch {
    return null
  }
}

apiClient.interceptors.request.use(config => {
  const accessToken = parseStoredJSON<string>('accessToken')

  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`
  }

  return config
})

apiClient.interceptors.response.use(
  config => {
    return config
  },
  async error => {
    const axiosError = error as AxiosError
    const originalRequest = axiosError.config as
      | (AxiosRequestConfig & { _isRetry?: boolean })
      | undefined

    if (axiosError.response?.status === 401 && originalRequest && !originalRequest._isRetry) {
      if (!isBrowser) {
        throw axiosError
      }

      originalRequest._isRetry = true
      if (apiClient.isAwaitRefresh) {
        return
      }
      apiClient.isAwaitRefresh = true
      try {
        const accessToken = parseStoredJSON<string>('accessToken')
        const refreshToken = parseStoredJSON<string>('refreshToken')

        if (!accessToken || !refreshToken) {
          localStorage.clear()
          window.location.href = '/login'

          return
        }

        const response = await axios.post(`${SERVER_URL}/api/Auth/refreshToken`, {
          accessToken,
          refreshToken,
        })

        if (response.status !== 200) {
          localStorage.clear()
          window.location.href = '/login'

          return
        }

        localStorage.setItem('accessToken', JSON.stringify(response.data?.accessToken))
        localStorage.setItem('refreshToken', JSON.stringify(response.data?.refreshToken))

        return apiClient.request(originalRequest)
      } catch (e) {
        localStorage.clear()
        window.location.href = '/login'
      } finally {
        apiClient.isAwaitRefresh = false
      }
    }
    throw axiosError
  }
)

export const createInstance = <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig
): Promise<T> => {
  return apiClient({
    ...config,
    ...options,
    // signal,
  }).then(r => r?.data)
}

export type BodyType<Data> = Data

export type ErrorType<Error> = AxiosError<Error>
